import { render, staticRenderFns } from "./Loginicon.vue?vue&type=template&id=2f59d84c&"
import script from "./Loginicon.vue?vue&type=script&lang=ts&"
export * from "./Loginicon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports